import React, { useState } from "react";
import "./whatsapp.scss";
import logoWhatsapp from "../../assets/logoWhatsapp.png";

const initialState = {
  nombre: "",
  celular: "",
  email: "",
};
const initialTouched = {
  nombre: false,
  celular: false,
  email: false,
};
const initialFocus = {
  nombre: false,
  celular: false,
  email: false,
};

const validate = (values) => {
  const errors = {};
  const nombre = values.nombre.trim();
  const celular = values.celular.trim();
  const email = values.email.toLowerCase().trim();
  if (!nombre || !/^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/.test(nombre)) {
    errors.nombre = "Por favor, revisá este campo nuevamente.";
  }
  // Email validation
  const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
  if (!emailPattern.test(email)) {
    errors.email = "Email debe tener el formato: ejemplo@ejemplo.com";
  }
  // Phone validation
  const phonePattern = /^\d{10}$/;
  if (!phonePattern.test(celular)) {
    errors.celular = "Solo números, sin 0 y sin 15. Ej. 351 5 123456";
  }
  return errors;
};

const handleKeyDown = (event) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "Tab",
    "Escape",
    "Enter",
    "ArrowLeft",
    "ArrowRight",
    "ArrowUp",
    "ArrowDown",
  ];
  if (allowedKeys.includes(event.key)) return;
  if (!/^\d+$/.test(event.key)) {
    event.preventDefault();
  }
};

const WhatsAppModal = ({ open, onClose, onSubmit, loading }) => {
  const [values, setValues] = useState(initialState);
  const [touched, setTouched] = useState(initialTouched);
  const [focus, setFocus] = useState(initialFocus);
  const [errors, setErrors] = useState({});

  if (!open) return null;

  const handleChange = (e) => {
    let val = e.target.value;
    if (e.target.name === "celular") {
      val = val.replace(/\D/g, "").trim();
    }
    // Para email, convertir a minúsculas y trim en tiempo real
    if (e.target.name === "email") {
      val = val.toLowerCase().trim();
    }
    setValues({ ...values, [e.target.name]: val });
    // Validar en tiempo real
    if (e.target.name === "nombre") {
      if (!val.trim() || !/^[A-Za-zÁÉÍÓÚáéíóúÑñ ]+$/.test(val.trim())) {
        setErrors((prev) => ({ ...prev, nombre: "Por favor, revisá este campo nuevamente." }));
      } else {
        setErrors((prev) => ({ ...prev, nombre: "" }));
      }
    } else if (e.target.name === "celular") {
      const phonePattern = /^\d{10}$/;
      if (!phonePattern.test(val)) {
        setErrors((prev) => ({ ...prev, celular: "Solo números, sin 0 y sin 15. Ej. 351 5 123456" }));
      } else {
        setErrors((prev) => ({ ...prev, celular: "" }));
      }
    } else if (e.target.name === "email") {
      const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
      if (!emailPattern.test(val)) {
        setErrors((prev) => ({ ...prev, email: "Email debe tener el formato: ejemplo@ejemplo.com" }));
      } else {
        setErrors((prev) => ({ ...prev, email: "" }));
      }
    }
    // Validar el formulario completo en tiempo real
    const newErrors = validate({ ...values, [e.target.name]: val });
    setErrors(newErrors);
  };

  const handleBlur = (e) => {
    setTouched({ ...touched, [e.target.name]: true });
    setFocus({ ...focus, [e.target.name]: false });
    setErrors(validate({ ...values, [e.target.name]: e.target.value }));
  };

  const handleFocus = (e) => {
    setFocus({ ...focus, [e.target.name]: true });
    if (e.target.name === "email") {
      const newErrors = validate(values);
      setErrors(newErrors);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Al enviar, pasar el email y celular a minúsculas y trim
    const valuesToSend = {
      ...values,
      email: values.email.toLowerCase().trim(),
      celular: values.celular.trim(),
    };
    const newErrors = validate(valuesToSend);
    setErrors(newErrors);
    setTouched({ nombre: true, celular: true, email: true });
    if (Object.keys(newErrors).length === 0) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "whatsapp_form_submit",
        form_name: "formulario_whatsapp", // Reemplazar por el ID o nombre real del formulario si aplica
        user_intention: "contactar_por_whatsapp", // Objetivo del usuario
      });
      onSubmit(valuesToSend);
    }
  };

  const getInputClass = (field) => {
    if (errors[field] && touched[field]) return "wsp-input error";
    if (!errors[field] && values[field]) return "wsp-input success";
    if (focus[field]) return "wsp-input focused";
    return "wsp-input";
  };

  const isFormValid = () => {
    return Object.keys(errors).length === 0 && values.nombre && values.celular && values.email;
  };

  return (
    <div className="wsp-modal-overlay">
      <div className="wsp-modal">
        <button className="wsp-modal-close" onClick={onClose}>
          &times;
        </button>
        <div style={{ display: "flex", justifyContent: "flex-start", marginBottom: 10 }}>
          <img src={logoWhatsapp} alt="whatsapp" style={{ width: 58, height: 58 }} />
        </div>
        <h6 className="pt-1 pb-1">
          Estamos casi listos para ayudarte. <br />
          Completa tus datos y te derivaremos a WhatsApp.
        </h6>
        <form onSubmit={handleSubmit} className="wsp-form" autoComplete="off">
          <label>
            Nombre y apellido*
            <input
              name="nombre"
              placeholder="Ej: María González"
              value={values.nombre}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleFocus}
              className={getInputClass("nombre")}
            />
            {errors.nombre && touched.nombre && <span className="wsp-error-msg">{errors.nombre}</span>}
          </label>
          <label>
            Nro. de celular*
            <input
              name="celular"
              placeholder="Código de área sin 0 + nro. de celular sin 15"
              value={values.celular}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleFocus}
              className={getInputClass("celular")}
              minLength={10}
              maxLength={10}
              onKeyDown={handleKeyDown}
              onInput={(e) => {
                e.target.value = e.target.value.replace(/\D/g, "");
              }}
              required
            />
            {errors.celular && touched.celular && <span className="wsp-error-msg">{errors.celular}</span>}
          </label>
          <label>
            E-mail*
            <input
              name="email"
              placeholder="Ej: maria@email.com"
              value={values.email}
              onChange={handleChange}
              onBlur={handleBlur}
              onFocus={handleFocus}
              className={getInputClass("email")}
              required
            />
            {errors.email && touched.email && <span className="wsp-error-msg">{errors.email}</span>}
          </label>
          <button type="submit" className="wsp-btn-submit" disabled={loading || !isFormValid()}>
            {loading ? "Te estamos derivando a Whatsapp..." : "Validar y Chatear en WhatsApp"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default WhatsAppModal;
